import React, { useState } from 'react';
import { Button, Row } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import Pagination from '../pagination/paginationpage';

function CustomTable({ columns, rowsData, page, setPage, metaData, limit }) {
  console.log('metaData', metaData)

  const [recordsPerPage] = useState(10);

  const indexOfLastRecord = page * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = rowsData.slice(indexOfFirstRecord, indexOfLastRecord);
  const nPages = Math.ceil(rowsData.length / recordsPerPage)

  const previousPage = () => {
    if (page !== 1) {
      setPage(page - 1)
    }
  };
  const canNextPage = page < metaData?.pageSize;
  const nextPage = () => {
    if (page < metaData?.pageSize) {
      setPage(page + 1)
    }
  };
  const canPreviousPage = page > 1

  const pageSize = metaData?.pageSize || 5; // Default page size is set to 5

  const renderPaginationNumbers = () => {
    const totalPages = Math.ceil(metaData?.count / pageSize);
    const startPage = Math.max(1, Math.min(page - 2, totalPages - 4));
    const endPage = Math.min(startPage + 4, totalPages);

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li className={page === i ? 'page-item active' : 'page-item'} key={i}>
          <Button variant="link" className="page-link" onClick={() => setPage(i)}>{i}</Button>
        </li>
      );
    }
    return pages;
  };


  return (
    <>

      <Table responsive>
        <thead>
          <tr>
            {
              columns?.map(it => (
                <th key={it?.Header}>{it?.Header}</th>
              ))
            }

          </tr>
        </thead>
        <tbody>
          {/* <td >    {page > 1 ? limit *( page -1) + index + 1 : index + 1}</td> */}
          {rowsData?.length > 0 ?
            rowsData?.map((it, index) => {
              return (<tr key={it?.id || index}>
                {
                  columns?.map((sIt, ind) => {
                    if (sIt?.CustomDesign) {
                      return (
                        <td key={ind}>{sIt?.CustomDesign(it)}</td>
                      )

                    }

                    return (

                      <td key={ind}>{it?.[sIt?.fieldName]}</td>
                    )
                  })
                }
                {/* <td>{it?.[fieldName]}</td> */}
              </tr>
              )
            })
            :
            <p className='text-center'>No order Found</p>
          }

        </tbody>

      </Table>

      <Row className="align-items-center mt-2 py-2 px-2 gy-2 text-center text-sm-start">
        <div className="col-sm">
          <p className="text-muted flex-grow-1 mb-0">{metaData?.lowerLimit ? `Showing ${metaData?.lowerLimit}-${metaData?.upperLimit} of ${metaData?.count} results` : ''}</p>


        </div>
        <div className="col-sm-auto">
          <Pagination
            renderPaginationNumbers={renderPaginationNumbers()}
            previousPage={previousPage}
            nextPage={nextPage}
            canPreviousPage={canPreviousPage}
            canNextPage={canNextPage}
          />
        </div>
      </Row>
    </>
  );
}

export default CustomTable;